import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSessionExpired, resetAuth } from "@/redux/slice/auth.slice";
import styled from "styled-components";
import { useNavigate , useLocation} from "react-router-dom";
import { removeAuthToken } from "@/utils/storage";

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  background: white;
  padding: 1rem 4rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const PopupTitle = styled.h1`
  margin-bottom: 1rem;
  font-size: 1.5rem;
`;

const PopupMessage = styled.p`
  margin-bottom: 2rem;
  font-size: 1rem;
`;

const PopupButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  color: white;
  background: #131c26;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    background: #16212d;
  }
`;

const SessionExpiredPopup = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const userType = location.pathname.split("/")[1];
  const navigate = useNavigate();
  const { sessionExpired } = useSelector((state) => state.auth);

  const handleClose = () => {
    dispatch(clearSessionExpired());
    dispatch(resetAuth());
    removeAuthToken();
    
    navigate(`/${userType}/login`);
  };

  // const isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === "staging";

  // useEffect(() => {
  //   if (isDev) return; // Skip effect in development mode

  //   const handleContextMenu = (e) => e.preventDefault();
  //   const handleKeyDown = (e) => {
  //     if (
  //       (e.ctrlKey && e.shiftKey && e.key === 'I') ||
  //       (e.ctrlKey && e.shiftKey && e.key === 'C') ||
  //       (e.ctrlKey && e.shiftKey && e.key === 'J') ||
  //       (e.ctrlKey && e.key === 'U') ||
  //       e.key === 'F12'
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener('contextmenu', handleContextMenu);
  //   document.addEventListener('keydown', handleKeyDown);

  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu);
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, [isDev]);


  if (!sessionExpired) return null;

  return (
    <PopupOverlay>
      <PopupContent>
        <PopupTitle>Session Expired</PopupTitle>
        <PopupMessage>Please login again to continue.</PopupMessage>
        <PopupButton onClick={handleClose}>Log In</PopupButton>
      </PopupContent>
    </PopupOverlay>
  );
};

export default SessionExpiredPopup;
